$(document).ready(function(){
  $('.custom-tabs ul.tabs li').on('click', function(){
    console.log('click');
   var tab_id = $(this).attr('data-tab');
   $('.custom-tabs ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $('#'+tab_id).addClass('current');
  });

    var $status = $('.custom_media_slider_btn .slider-buttons .pagingInfo');
    var $slickElement = $('.custom_product__media-list');
    
    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
    });
  
    $('.custom_product__media-list').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          infinite:false,
          fade: false,
          swipeToSlide: false,
          asNavFor: '.custom-thumbnail-list',
          prevArrow: $('.custom_media_slider_btn .slider-button--prev'),
          nextArrow: $('.custom_media_slider_btn .slider-button--next'),
          draggable: false,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                 draggable: true 
              }
          }
         ]
        });
      $('.custom-thumbnail-list').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '.custom_product__media-list',
          focusOnSelect: true,
          arrows: false,
          accessibility: true,
          vertical:true,
          verticalSwiping:true
        
      });

 
    
// menu

  let items = document.querySelectorAll(".mega-menu")
  let header = document.querySelector('header')
  let currentItemIndex
  
  items.forEach((item, itemIndex) => {
    const content = item.querySelector(".mega-menu__content")
    item.addEventListener("mouseover", () => {
      if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex && currentItemIndex !== itemIndex)
      ) {
        items[currentItemIndex].removeAttribute("open")
      }

      currentItemIndex = itemIndex
      item.setAttribute("open", true)
    })

    item.addEventListener("mouseleave", (event) => {
      let close = true

      const closeTimeout = setTimeout(() => {
        if (close) item.removeAttribute("open")
      }, 100)
      
      content.addEventListener("mouseover", () => {
        close = false
      })

      item.addEventListener("mouseover", () => {
        clearTimeout(closeTimeout)
      })
    })

    content.addEventListener("mouseleave", () => {
      item.removeAttribute("open")
    })
  });
  
  
});

jQuery(document).ready(function() {
   jQuery(".faq-icon-container-background").on('click', function(event) {
    let faqContainer = jQuery('.faq-questions-container');
    if (faqContainer.hasClass('hidden')) {
      faqContainer.removeClass('hidden');
    }
    // document.querySelector('.faq-questions-container').scrollIntoView({ behavior: 'smooth' });
      let targetOffset = jQuery('.faq-questions-container').offset().top - jQuery('sticky-header').height();
      jQuery('html, body').animate({scrollTop: targetOffset}, 300);
      let titleId = jQuery(this).data('title-id');
      jQuery(".faq-container").hide();
      jQuery(`.faq-container[data-title-id="${titleId}"]`).show();
      jQuery("#faq-question-header h2").text($(this).find('.faq-icon-title').text());
  });
});

// homepage slider
    $('.custom-slider ul').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          infinite:true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                  slidesToShow: 3,
              }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            }
         ]
        });



// drawer js
// function handleSlick(){
//   $('.mobile-upsell .add-data').slick({
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1, 
//     dots:false,
//     arrows:false,
//     centerMode: true,
//     centerPadding:'30px',
//    });
  
// }
// handleSlick();

// function ReBuildSlider(){
//  if($('.mobile-upsell .add-data').hasClass('slick-initialized') == true ){
//      $('.mobile-upsell .add-data').slick('unslick');
//       setTimeout(function(){
//          handleSlick()
//       },1500)
//     }else{ 
//        setTimeout(function(){
//         handleSlick()
//       },1500)
//     }
//  }

// $('.free-gift-box').click(function(){
//   if($(this).is(":checked"))  {
//     let var_id =  $(this).data('variant_id');
//     console.log(var_id);
//       $(this).closest('.cart-gift').find('.giftcart-form product-form input[name="id"]').val(var_id);
//       let button = $(this).closest('.cart-gift').find('.giftcart-form product-form button');
//     button.trigger('click');
//   }else{
//        $(this).closest('.cart-gift').find('.giftcart-form product-form input[name="id"]').val('');
//   }

// });


// add on slider
$('.custom_addons_items').slick({
     infinite: true,
     slidesToShow: 3,
     slidesToScroll: 1, 
     dots:false,
     arrows:true,
     adaptiveHeight:true,
     responsive: [
            {
              breakpoint: 768,
              settings: {
                    slidesToShow: 2,
                    arrows:false,
                    dots:true,
                    
              }
            }
            
         ]
 });



// product page upload image

var MAX_SIZE = 1024 * 1024 * 5; // 5 MB
var VALID_TYPES = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'];

var input = document.getElementById( 'file-upload' );
var infoArea = document.getElementById( 'file-upload-filename' );

function validateFile() {
 // the change event gives us the input it occurred in 
  var input = event.srcElement;
  
  // the input has an array of files in the `files` property, each one has a name that you can use. We're just using the name here.
  var fileName = input.files[0].name;
  
  // use fileName however fits your app best, i.e. add it into a div
  infoArea.textContent = ' ' + fileName;
if (this.files && this.files.length) {
		var file = this.files[0];
		
		//console.log(file);
		var type = file.type;
		var size = file.size;
		var fileNameSplit = file.name.split('.');
		var extension = fileNameSplit[fileNameSplit.length - 1];
		
		//console.log(type);
		//console.log(extension);
		//console.log(size);
		
		if (size > MAX_SIZE) {
			$('#error-file-too-large').addClass('state-visible');
                    $('.shop-button.enj-add-to-cart-btn.engoj-btn-addtocart').removeAttr("disabled","disabled")
		} else {
			$('#error-file-too-large').removeClass('state-visible'); 
        }
		
		if (VALID_TYPES.indexOf(type) < 0) {
			$('#error-invalid-type').addClass('state-visible');
                    $('.shop-button.enj-add-to-cart-btn.engoj-btn-addtocart').removeAttr("disabled","disabled")
		} else {
			$('#error-invalid-type').removeClass('state-visible');
          
		}
	}
}

function validateFile2() {
  var infoArea2 = document.getElementById( 'file-upload-filename2' );
 // the change event gives us the input it occurred in 
  var input = event.srcElement;
  
  // the input has an array of files in the `files` property, each one has a name that you can use. We're just using the name here.
  var fileName = input.files[0].name;
  
  // use fileName however fits your app best, i.e. add it into a div
  infoArea2.textContent = ' ' + fileName;
if (this.files && this.files.length) {
		var file = this.files[0];
		
		//console.log(file);
		var type = file.type;
		var size = file.size;
		var fileNameSplit = file.name.split('.');
		var extension = fileNameSplit[fileNameSplit.length - 1];
		
		//console.log(type);
		//console.log(extension);
		//console.log(size);
		
		if (size > MAX_SIZE) {
			$('#error-file-too-large').addClass('state-visible');
                    $('.shop-button.enj-add-to-cart-btn.engoj-btn-addtocart').removeAttr("disabled","disabled")
		} else {
			$('#error-file-too-large').removeClass('state-visible'); 
        }
		
		if (VALID_TYPES.indexOf(type) < 0) {
			$('#error-invalid-type').addClass('state-visible');
                    $('.shop-button.enj-add-to-cart-btn.engoj-btn-addtocart').removeAttr("disabled","disabled")
		} else {
			$('#error-invalid-type').removeClass('state-visible');
          
		}
	}
}



$(document).ready(function() {
	$('#custom_photo_add').on('change', validateFile);
	$('#custom_photo_add2').on('change', validateFile2);
  
});


$('.authorised_box input').click(function(){
    if ($(this).is(':checked')) {
        $('this').val('Yes');
    }else{
          $(this).val('No');
    }
});

  $('.greating-message-box textarea').keyup(function() {
    let characterCount = $(this).val().length;
    let current = $('#current-length');
    let maximum = $('#maximum-length');
    current.text(characterCount);
  });



/// Main logic to handle product protection based on specific variant


function updateCartDrawerHTML() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble,main-cart-items')
        .then(res => res.json())
        .then(data => {
            const parser = new DOMParser();

            // Cart Drawer
            if (data['cart-drawer']) {
                const cartDrawerHTML = parser.parseFromString(data['cart-drawer'], 'text/html');
                const newDrawer = cartDrawerHTML.querySelector('#CartDrawer');
                const currentDrawer = document.querySelector('#CartDrawer');
                if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
            }

            // Cart Icon Bubble
            if (data['cart-icon-bubble']) {
                const bubbleHTML = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
                const newBubble = bubbleHTML.querySelector('.cart-count-bubble span');
                const currentBubble = document.querySelector('.cart-count-bubble span');
                if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
            }

            // Main Cart Items
            if (data['main-cart-items']) {
                const cartPageHTML = parser.parseFromString(data['main-cart-items'], 'text/html');
                const newCartPage = cartPageHTML.querySelector('cart-items');
                const currentCartPage = document.querySelector('cart-items');
                if (newCartPage && currentCartPage) currentCartPage.innerHTML = newCartPage.innerHTML;
            }

            return fetch('/cart.js').then(res => res.json());
        })
        .then(cart => {
            const themeCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const themeCartPage = document.querySelector('cart-items');
            const themeCartItem = document.querySelector('cart-drawer-items');

            if (cart.item_count === 0) {
                if(themeCart) themeCart.classList.add('is-empty');
                if(themeCartItem) themeCartItem.classList.add('is-empty');
                if(themeCartPage) themeCartPage.classList.add('is-empty');
            } else {
                if(themeCart) themeCart.classList.remove('is-empty');
            }
        });
}


function handleProductProtection() {
    const productProtectionId = $('body').data('product_protection');
    const requiredVariantId = $('body').data('product_protection_on');

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const items = cart.items;
            let hasRequiredVariant = false;
            let hasProductProtection = false;
            let productProtectionLine = null;

            items.forEach((item, index) => {
                if (item.variant_id === requiredVariantId) hasRequiredVariant = true;
                if (item.variant_id === productProtectionId) {
                    hasProductProtection = true;
                    productProtectionLine = index + 1;
                }
            });

            if (hasRequiredVariant && !hasProductProtection) {
                addProductProtection(productProtectionId);
            } else if (!hasRequiredVariant && hasProductProtection) {
                removeProductProtection(productProtectionLine);
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
}

function addProductProtection(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: variantId,
                quantity: 1,
                properties: { "Important": "Rental returned on time (within 3 days): You will receive a full refund of your security deposit." }
            }]
        })
    })
    .then(() => updateCartDrawerHTML())
    .then(() => handleProductProtection())
    .catch(error => console.error('Error adding product protection:', error));
}

function removeProductProtection(line) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(() => updateCartDrawerHTML())
    .then(() => handleProductProtection())
    .catch(error => console.error('Error removing product protection:', error));
}


// Run on page load
document.addEventListener('DOMContentLoaded', handleProductProtection);